import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MongoDBDataAdapter } from "@graylog/enterprise-api";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import MongoDBDataAdapterEntry from "../models/MongoDBDataAdapterEntry";
const URL = "/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/";
const adapterUrl = (path) => {
  const effectivePath = path ? `${URL}${path}` : URL;
  return qualifyUrl(effectivePath);
};
export const MONGODB_DATA_ADAPTER_QUERY_KEY = ["mongodb-data-adapter"];
const _responseToPaginatedEntries = (response) => ({
  pagination: {
    total: response.total,
    page: response.page,
    perPage: response.per_page,
    count: response.count
  },
  entries: response.entries.map((entry) => MongoDBDataAdapterEntry.fromJSON(entry))
});
export const createMongoDBDataAdapterEntry = (entry) => fetch("POST", adapterUrl(entry.dataAdapterId), entry.toJSON());
export const updateMongoDBDataAdapterEntry = (entry) => fetch("PUT", adapterUrl(`${entry.dataAdapterId}/${entry.id}`), entry.toJSON());
export const deleteMongoDBDataAdapterEntry = (entry) => MongoDBDataAdapter.remove(entry.dataAdapterId, entry.id);
export const useMongoDBDataAdapterEntries = ({ dataAdapterId, query, page, perPage }) => useQuery({
  queryKey: [...MONGODB_DATA_ADAPTER_QUERY_KEY, "entries", { dataAdapterId, query, page, perPage }],
  queryFn: () => MongoDBDataAdapter.get(void 0, dataAdapterId, page, perPage, void 0, query).then(_responseToPaginatedEntries).catch((error) => {
    UserNotification.error(
      i18n.t("notifications.data_adapter_entries_failed", { ns: "enterprise_lookup", error: error.message }),
      i18n.t("notifications.data_adapter_entries_failed_title", { ns: "enterprise_lookup" })
    );
    throw error;
  }),
  placeholderData: keepPreviousData,
  retry: false
});
export const useMongoDBDataAdapterStats = (adapterId) => useQuery({
  queryKey: [...MONGODB_DATA_ADAPTER_QUERY_KEY, "stats", adapterId],
  queryFn: () => MongoDBDataAdapter.stats(adapterId).then((response) => ({
    entriesCount: response.entries_count
  })),
  retry: false
});
